import React from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { Container } from './styles';

const RoomQuantityTooltip = ({
  children
}) => {

  return (
    <>
      <style>
        {`
          .rc-tooltip-placement-right > .rc-tooltip-arrow {
            top: 21px !important;  
          }
          .rc-tooltip-placement-right > .rc-tooltip-arrow::before {
            top: -16.5px;
          } 
        `}
      </style>
      <Tooltip
        placement="right"
        trigger={['hover']}
        overlay={
          <Container>
            <div className="tooltip-text">Please select room type first.</div>
          </Container>
        }
      >
        {children}
      </Tooltip>
    </>
  );
}

export default RoomQuantityTooltip;
